import { VueWizard, } from '@/vue-wizard';
import {Component, Watch} from "vue-property-decorator";
import {RegisterAction} from "@/app/interfaces";
import {store} from "@/app/store";
import RegisterForm from '@/app/components/register-form/RegisterForm.vue';
import PlanSelector from "@/app/components/plan-selector/PlanSelector.vue";
import FlowManager from '../flow/flow-manager/FlowManager.vue';
import $ from 'jquery';

@Component({
    name: 'register-views-holder',
    components: {
        PlanSelector, RegisterForm, FlowManager
    }
})
export default class RegisterViewsHolder extends VueWizard {

    public showHelper: boolean;
    public helperMessage: string | null;

    constructor() {
        super();
        this.showHelper = false;
        this.helperMessage = null;
    }

    get currentActionIndex(): number {
        return store.state.currentActionIndex;
    }

    get registerActions(): RegisterAction[] {
        return store.state.registerActions;
    }

    get activeAction(): RegisterAction {
        return this.registerActions[this.currentActionIndex];
    }

    @Watch('activeAction')
    watchActiveAction() {
        ($('#helper-message-btn') as any).tooltip('disable')
        this.helperMessage = null;
        this.showHelper = false;
    }

    showRegisterViewHelper(message: string) {
        this.showHelper = true;
        this.helperMessage = message;
        $(() => ($('#helper-message-btn') as any).tooltip())
    }

}